import { createStore } from 'vuex'

const USER_STORAGE_KEY = 'usuario_admin'
const USER_STORAGE_KEY_LEGADO = 'admin_user'

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

const loadFromStorage = (key, fallback) => {
  if (!isBrowser()) return fallback
  const raw = window.localStorage.getItem(key)
  if (!raw) return fallback
  try {
    return JSON.parse(raw)
  } catch (error) {
    console.warn(`[store] No se pudo parsear ${key} desde localStorage`, error)
    return fallback
  }
}

const loadFromStorageMulti = (keys, fallback) => {
  for (const key of keys) {
    const value = loadFromStorage(key, null)
    if (value !== null) return value
  }
  return fallback
}

const persist = (key, value) => {
  if (!isBrowser()) return
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.warn(`[store] No se pudo persistir ${key} en localStorage`, error)
  }
}

const remove = (key) => {
  if (!isBrowser()) return
  window.localStorage.removeItem(key)
}

export default createStore({
  state: {
    user: loadFromStorageMulti([USER_STORAGE_KEY, USER_STORAGE_KEY_LEGADO], null)
  },
  getters: {
    isAuthenticated: state => Boolean(state.user),
    currentUser: state => state.user
  },
  mutations: {
    setUser(state, user) {
      state.user = user || null
      if (user) {
        persist(USER_STORAGE_KEY, state.user)
      } else {
        remove(USER_STORAGE_KEY)
      }
    },
    clearAuth(state) {
      state.user = null
      remove(USER_STORAGE_KEY)
      remove(USER_STORAGE_KEY_LEGADO)
    }
  },
  actions: {
    hydrateFromStorage({ commit }) {
      commit('setUser', loadFromStorageMulti([USER_STORAGE_KEY, USER_STORAGE_KEY_LEGADO], null))
    }
  },
  modules: {}
})
